<template>
	<div>
		<Loader :show="loading" type="absolute" />

		<div class="" :class="{ minified: minified, expanded: expanded }" v-if="!loading">
			<div class="main-data">
				<div class="px-2 avatar-circle">
					<b-avatar v-if="item.avatarUrl" :src="item.avatarUrl" variant="light" size="7rem"></b-avatar>
					<b-avatar v-else variant="light" size="7rem"></b-avatar>
				</div>

				<div>
					<div class="label">MEDICO</div>
					<h2 class="m-0">{{ item.name }} {{ item.lastname }}</h2>
					<div v-if="item.cjp">CJP: {{ item.cjp }}</div>

					<!-- <b-collapse id="clientDataCollpsed" class="text-secondary client-data m-0 mt-3" v-model="expanded">
                    <div v-if="item.phone"><i class="icon icon-phone"></i> {{item.phone.international}}</div>
                    <div><i class="icon icon-envelope-o"></i> {{item.email}}</div>
                                
                    <div v-if="item.birthdate"><i class="icon icon-calendar"></i> {{item.birthdate | moment("DD-MM-YYYY")}}  ( {{item.age}} años )</div>

                    <div class="btns">
                        <a class="btn btn-icon-circle btn-success" :href="`tel:${item.phone.international}`" target="_blank" v-if="item.phone">
                            <i class="icon icon-phone"></i>
                        </a>
                        <a class="btn btn-icon-circle btn-success" :href="`mailto:${item.email}`" target="_blank">
                            <i class="icon icon-envelope-o"></i>
                        </a>
                        <a class="btn btn-icon-circle btn-success" :href="`sms:${item.phone.international}&body=Estimado%20${item.name}`" target="_blank" v-if="item.phone">
                            <i class="icon icon-chat"></i>
                        </a>
                        <a class="btn btn-icon-circle btn-whatsapp" :href="`https://api.whatsapp.com/send?phone=${item.phone.international}&text=Estimado%20${item.name}`" target="_blank" v-if="item.phone">
                            <i class="icon icon-whatsapp"></i>
                        </a>
                    </div>

                </b-collapse>  -->
				</div>
			</div>

			<!-- <div class="btn btn-block" v-b-toggle.clientDataCollpsed>
            <div v-if="expanded" class="icon icon-up-open-mini"></div>
            <div v-if="!expanded" class="icon icon-down-open-mini"></div>
        </div> -->
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "MedicCard",
	props: {
		id: {
			required: true
		},
		minified: { default: false },
		expanded: { type: Boolean, default: false },
		canEdit: { type: Boolean, default: false }
	},
	data() {
		return {
			loading: false,
			item: null
		}
	},
	async beforeMount() {
		this.loading = true
		await this.load()
		this.loading = false
	},
	methods: {
		load() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							medic(id: $id) {
								id
								name
								lastname
								cjp
							}
						}
					`,
					variables: { id: this.id },
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.item = data.medic
				})
		}
	}
}
</script>

<style scoped>
h2 {
	font-size: 1.2rem;
}

.main-data {
	text-align: left;
}

.btn-icon-circle {
	font-size: 1.4rem;
	width: 42px;
	height: 42px;
	margin: 8px;
	color: #b6b6b6;
	background-color: #fff;
	border-color: #b6b6b6;
}
.btn-icon-circle:hover {
	color: #fff;
	background-color: #143155;
	border-color: #143155;
}
.btn-icon-circle.btn-whatsapp:hover {
	color: #fff;
	background-color: #25d366;
	border-color: #25d366;
}

.table .icon {
	display: inline-flex;
	color: #b6b6b6;
}
.btns {
	display: flex;
}

.b-avatar {
	border: solid 2px #005eb8;
}

.client-data {
	display: flex;

	flex-direction: column;
}
.client-data > div {
	display: inline-flex;
	align-items: center;
	margin-top: 6px;
}
.client-data > div > .icon {
	margin-right: 8px;
}

.stars {
	display: inline-flex;
	align-items: center;
	color: #3a82dc;
	line-height: 3px;
}

.minified {
}
.minified .b-avatar {
	width: 5rem !important;
	height: 5rem !important;
}
.minified .main-data {
	text-align: left;
	display: inline-flex;
	flex-wrap: wrap;
}
.minified .btn-icon-circle {
	font-size: 16px;
	width: 32px;
	height: 32px;
}

.minified .avatar-circle {
	display: none;
}
.minified.expanded .avatar-circle {
	display: flex;
}
</style>
